<template>
  <div class="down-box">
    <p class="tip-m">推荐您在“<span @click="downLoad">大国工匠客户端</span>”中下载模型！</p>
  </div>
</template>

<script>
import {CheckLibs} from '@digital-supply-chain/module'

export default {
  methods: {
    downLoad() {
      window.md.openUrl('https://down.global-dsc.cn/Release/dggj/dggj.exe');
      // if (CheckLibs.isClient()) {
      //   window.md.openUrl('https://down.global-dsc.cn/Release/dggj/dggj.exe');
      // } else {
      //   window.open('https://down9.maidiyun.com/release/bige/BigEInstall_Release.exe');
      // }
    }
  },
}
</script>

<style lang="less" scoped>
.down-box{
  width: 100%;
  height: 42px;
  background: #F1F1F1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  position: relative;
}
.tip-m{
  margin: 0;
  color: #333333;
  font-size: 14px;
  span{
    color: #0989c5;
    cursor: pointer;
  }
}
</style>
